import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "top",
        "right",
        "bottom",
        "left",
        "rotating"
    ]

    refreshLengths(event) {
        if (!this.rotatingTarget.checked) {
            return;
        }

        const newLength = (event.currentTarget === this.rotatingTarget) ?
            this.lengthTargets().reduce(function (accumulator, lengthTarget) {
                return Math.max(accumulator, lengthTarget.value);
            }, 0) : event.currentTarget.value;

        this.lengthTargets().forEach(function (lengthTarget) {
            if (lengthTarget !== event.currentTarget) {
                lengthTarget.value = newLength;
            }
        });
    }

    lengthTargets() {
        return [
            this.topTarget,
            this.rightTarget,
            this.bottomTarget,
            this.leftTarget
        ];
    }
}